import { c as _c } from "react/compiler-runtime";
import { CheckCircle, X } from 'lucide-react';
import { Button } from '@/shared/components/ui/common/Button';
import { TextArea } from '@/shared/components/ui/common/TextArea';
import { COMENTARIO_MAX_CARACTERES, NOTA_MAXIMA } from '../constants/catalogoMomentos';
import type { MomentoPesquisa, PesquisaEstado } from '../types/pesquisaSatisfacaoTypes';
import { notaEhAlta } from '../utils/tomDaNota';
import { EscalaPesquisa } from './escala/EscalaPesquisa';
import { SeloNota } from './escala/SeloNota';
interface PesquisaSatisfacaoCardProps {
  momento: MomentoPesquisa;
  estado: PesquisaEstado;
  nota: number | null;
  comentario: string;
  progressoPercentual: number;
  enviandoComentario: boolean;
  onSelecionarNota: (nota: number) => void;
  onAlterarComentario: (comentario: string) => void;
  onEnviarComentario: () => void;
  onFechar: () => void;
  onPausarTimer: () => void;
  onRetomarTimer: () => void;
}
const CLASSES_CARTAO = 'w-[392px] box-border rounded-[16px] border bg-neutral-0 shadow-xl border-neutral-200';
export function PesquisaSatisfacaoCard(t0) {
  const $ = _c(72);
  const {
    momento,
    estado,
    nota,
    comentario,
    progressoPercentual,
    enviandoComentario,
    onSelecionarNota,
    onAlterarComentario,
    onEnviarComentario,
    onFechar,
    onPausarTimer,
    onRetomarTimer
  } = t0;
  const notaMaxima = NOTA_MAXIMA[momento.tipo];
  const alta = nota !== null && notaEhAlta(momento.tipo, nota);
  const pergunta = alta ? momento.perguntaAlta : momento.perguntaBaixa;
  const placeholder = alta ? momento.placeholderAlta : momento.placeholderBaixa;
  if (estado === "ENVIADO") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <CheckCircle className="text-success-600 h-[22px] w-[22px] flex-none" aria-hidden="true" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div role="status" className={`${CLASSES_CARTAO} border-success-200 flex items-center gap-3 px-5 py-[18px]`}>{t1}<div className="flex flex-1 flex-col gap-0.5"><span className="text-success-700 text-sm font-semibold">Comentário enviado. Obrigado pelos dois.</span><span className="text-xs text-neutral-500">Não perguntamos de novo esta semana.</span></div></div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (estado === "COMENTARIO" && nota !== null) {
    let t1;
    if ($[2] !== momento.tipo || $[3] !== nota) {
      t1 = <SeloNota tipo={momento.tipo} nota={nota} />;
      $[2] = momento.tipo;
      $[3] = nota;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== nota || $[6] !== notaMaxima) {
      t2 = <span className="text-sm font-semibold text-neutral-800">Você deu {nota} de {notaMaxima}</span>;
      $[5] = nota;
      $[6] = notaMaxima;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex items-center gap-1.5"><CheckCircle className="text-success-600 h-4 w-4 flex-none" aria-hidden="true" /><span className="text-success-700 text-xs font-semibold">Nota enviada — já está com o time</span></div>;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== t2) {
      t4 = <div className="flex flex-1 flex-col gap-1">{t2}{t3}</div>;
      $[9] = t2;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== t1 || $[12] !== t4) {
      t5 = <div className="flex items-center gap-2.5">{t1}{t4}</div>;
      $[11] = t1;
      $[12] = t4;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== pergunta) {
      t6 = <span className="text-sm font-semibold text-neutral-800">{pergunta}</span>;
      $[14] = pergunta;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    let t7;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <span className="rounded-md bg-neutral-100 px-1.5 py-0.5 text-[11px] font-medium whitespace-nowrap text-neutral-500">opcional</span>;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    let t8;
    if ($[17] !== t6) {
      t8 = <div className="flex items-baseline gap-2">{t6}{t7}</div>;
      $[17] = t6;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    let t9;
    if ($[19] !== onAlterarComentario) {
      t9 = evento => onAlterarComentario(evento.target.value);
      $[19] = onAlterarComentario;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    const t10 = alta ? "min-h-[56px]" : "min-h-[76px]";
    let t11;
    if ($[21] !== comentario || $[22] !== placeholder || $[23] !== t10 || $[24] !== t9) {
      t11 = <TextArea><TextArea.Input value={comentario} placeholder={placeholder} maxLength={COMENTARIO_MAX_CARACTERES} data-dd-privacy="mask" onChange={t9} className={t10} /></TextArea>;
      $[21] = comentario;
      $[22] = placeholder;
      $[23] = t10;
      $[24] = t9;
      $[25] = t11;
    } else {
      t11 = $[25];
    }
    let t12;
    if ($[26] !== onFechar) {
      t12 = <button type="button" onClick={onFechar} className="flex-1 cursor-pointer text-left text-[13px] font-medium text-neutral-500 hover:text-neutral-700">Fechar sem comentar</button>;
      $[26] = onFechar;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    let t13;
    if ($[28] !== comentario || $[29] !== enviandoComentario) {
      t13 = enviandoComentario || comentario.trim().length === 0;
      $[28] = comentario;
      $[29] = enviandoComentario;
      $[30] = t13;
    } else {
      t13 = $[30];
    }
    let t14;
    if ($[31] !== onEnviarComentario || $[32] !== t13) {
      t14 = <Button variant="brand-primary" size="medium" disabled={t13} onClick={onEnviarComentario}>Enviar comentário</Button>;
      $[31] = onEnviarComentario;
      $[32] = t13;
      $[33] = t14;
    } else {
      t14 = $[33];
    }
    let t15;
    if ($[34] !== t12 || $[35] !== t14) {
      t15 = <div className="flex items-center gap-2.5">{t12}{t14}</div>;
      $[34] = t12;
      $[35] = t14;
      $[36] = t15;
    } else {
      t15 = $[36];
    }
    let t16;
    if ($[37] !== t11 || $[38] !== t15 || $[39] !== t8) {
      t16 = <div className="flex flex-col gap-2.5 border-t border-neutral-100 pt-3.5">{t8}{t11}{t15}</div>;
      $[37] = t11;
      $[38] = t15;
      $[39] = t8;
      $[40] = t16;
    } else {
      t16 = $[40];
    }
    let t17;
    if ($[41] !== onPausarTimer || $[42] !== onRetomarTimer || $[43] !== t16 || $[44] !== t5) {
      t17 = <div onMouseEnter={onPausarTimer} onMouseLeave={onRetomarTimer} className={`${CLASSES_CARTAO} flex flex-col gap-4 px-5 py-[18px]`}>{t5}{t16}</div>;
      $[41] = onPausarTimer;
      $[42] = onRetomarTimer;
      $[43] = t16;
      $[44] = t5;
      $[45] = t17;
    } else {
      t17 = $[45];
    }
    return t17;
  }
  let t1;
  if ($[46] !== momento.titulo) {
    t1 = <span className="text-[15px] leading-[21px] font-semibold text-neutral-800">{momento.titulo}</span>;
    $[46] = momento.titulo;
    $[47] = t1;
  } else {
    t1 = $[47];
  }
  let t2;
  if ($[48] !== momento.subtitulo) {
    t2 = <span className="text-xs text-neutral-500">{momento.subtitulo}</span>;
    $[48] = momento.subtitulo;
    $[49] = t2;
  } else {
    t2 = $[49];
  }
  let t3;
  if ($[50] !== t1 || $[51] !== t2) {
    t3 = <div className="flex flex-1 flex-col gap-[3px]">{t1}{t2}</div>;
    $[50] = t1;
    $[51] = t2;
    $[52] = t3;
  } else {
    t3 = $[52];
  }
  let t4;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <X className="h-4 w-4" aria-hidden="true" />;
    $[53] = t4;
  } else {
    t4 = $[53];
  }
  let t5;
  if ($[54] !== onFechar) {
    t5 = <button type="button" onClick={onFechar} aria-label="Fechar pesquisa" className="mt-[3px] flex-none cursor-pointer text-neutral-400 hover:text-neutral-600">{t4}</button>;
    $[54] = onFechar;
    $[55] = t5;
  } else {
    t5 = $[55];
  }
  let t6;
  if ($[56] !== t3 || $[57] !== t5) {
    t6 = <div className="flex items-start gap-2.5">{t3}{t5}</div>;
    $[56] = t3;
    $[57] = t5;
    $[58] = t6;
  } else {
    t6 = $[58];
  }
  let t7;
  if ($[59] !== momento.tipo || $[60] !== onSelecionarNota) {
    t7 = <EscalaPesquisa tipo={momento.tipo} onSelecionar={onSelecionarNota} />;
    $[59] = momento.tipo;
    $[60] = onSelecionarNota;
    $[61] = t7;
  } else {
    t7 = $[61];
  }
  let t8;
  if ($[62] !== t6 || $[63] !== t7) {
    t8 = <div className="flex flex-col gap-4 px-5 pt-[18px] pb-4">{t6}{t7}</div>;
    $[62] = t6;
    $[63] = t7;
    $[64] = t8;
  } else {
    t8 = $[64];
  }
  const t9 = `${progressoPercentual}%`;
  let t10;
  if ($[65] !== t9) {
    t10 = <div className="h-[3px] w-full bg-neutral-100"><div className="h-[3px] bg-neutral-300 transition-[width] duration-1000 ease-linear" style={{
        width: t9
      }} /></div>;
    $[65] = t9;
    $[66] = t10;
  } else {
    t10 = $[66];
  }
  let t11;
  if ($[67] !== onPausarTimer || $[68] !== onRetomarTimer || $[69] !== t10 || $[70] !== t8) {
    t11 = <div onMouseEnter={onPausarTimer} onMouseLeave={onRetomarTimer} className={`${CLASSES_CARTAO} overflow-hidden`}>{t8}{t10}</div>;
    $[67] = onPausarTimer;
    $[68] = onRetomarTimer;
    $[69] = t10;
    $[70] = t8;
    $[71] = t11;
  } else {
    t11 = $[71];
  }
  return t11;
}